"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = theme => ({
  tab: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    justifyContent: 'center',
    borderBottomStyle: 'solid',
    borderBottomColor: 'transparent',
    color: theme.tab.color,
    transition: theme.transition(['border-bottom-color']),
    boxSizing: 'border-box',
    '&:last-child': {
      marginRight: '0 !important'
    },
    '&:first-child': {
      marginLeft: '0 !important'
    },
    '&.active&:not(.withCustomColor):not(.error), &:hover&:not(.withCustomColor):not(.error)': {
      borderBottomColor: theme.tab.activeColor,
      '& $label': {
        color: theme.tab.activeColor
      },
      '& $icon': {
        '& .fill': {
          fill: theme.tab.activeColor
        },
        '& .stroke': {
          stroke: theme.tab.activeColor
        }
      },
      '&.disabled $label': {
        color: theme.tab.disabledColor
      }
    },
    '&:not(.active)&:hover&.withCustomColor': {
      background: 'initial !important'
    },
    '&:not(.active):not(:hover)': {
      borderBottomColor: 'transparent !important',
      background: 'initial !important',
      color: `${theme.tab.color} !important`,
      '& $label': {
        color: 'inherit'
      }
    },
    '&:not(.active):not(:hover).error': {
      color: `${theme.tab.errorColor} !important`
    },
    '&.error': {
      color: theme.tab.errorColor,
      '& $icon': {
        '& .fill': {
          fill: theme.tab.errorColor
        },
        '& .stroke': {
          stroke: theme.tab.errorColor
        }
      }
    },
    '&.error.active, &.error:hover': {
      borderBottomColor: `${theme.tab.errorColor} !important`
    },
    '&.active:hover': {
      cursor: 'default'
    },
    '&:not(.active)&.disabled, &:not(.active)&.disabled.error': {
      color: `${theme.tab.disabledColor} !important`,
      borderBottomColor: 'transparent !important',
      cursor: 'default',
      '& $icon': {
        '& .fill': {
          fill: theme.tab.disabledColor
        },
        '& .stroke': {
          stroke: theme.tab.disabledColor
        }
      }
    },
    '&.hidden': {
      display: 'none'
    }
  },
  fixed: {
    width: 0,
    flexGrow: 1
  },
  auto: {
    maxWidth: 300,
    minWidth: 20
  },
  icon: {
    '& .fill': {
      fill: theme.tab.color,
      transition: theme.transition(['fill'])
    },
    '& .stroke': {
      stroke: theme.tab.color,
      transition: theme.transition(['stroke'])
    }
  },
  leftIcon: {
    '& + $label': {
      marginLeft: 8
    }
  },
  rightIcon: {
    '$label + &': {
      marginLeft: 8
    }
  },
  label: {
    color: 'inherit',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    textAlign: 'center'
  },
  children: {
    marginLeft: 8
  },
  small: {
    padding: '2px 0 8px 0',
    borderBottomWidth: theme.tab.smallHeightUnderline,
    '&$indentsmall': {
      margin: '0 8px'
    },
    '&$indentmedium': {
      margin: '0 12px'
    },
    '&$indentlarge': {
      margin: '0 16px'
    }
  },
  medium: {
    padding: '4px 0 12px 0',
    borderBottomWidth: theme.tab.mediumHeightUnderline
  },
  indentsmall: {
    margin: '0 12px'
  },
  indentmedium: {
    margin: '0 16px'
  },
  indentlarge: {
    margin: '0 22px'
  }
});
exports.default = _default;